import { useMemo } from "react";
import cx from "classnames";
import { Button, Flex, Text } from "@radix-ui/themes";
import styles from "./browser-skill-auth.module.scss";

export type BrowserSkillAuthSession = {
  sessionId: string;
  liveViewUrl: string;
  profileName: string;
  profileId: string;
};

type BrowserSkillAuthContentProps = {
  session: BrowserSkillAuthSession;
  submitting: boolean;
  error?: string;
  onCancel: () => void;
  onFinish: () => void;
};

export function BrowserSkillAuthContent({
  session,
  submitting,
  error,
  onCancel,
  onFinish,
}: BrowserSkillAuthContentProps) {
  const containerClassName = useMemo(
    () => cx(styles.container, styles.dialog),
    []
  );

  const frameClassName = useMemo(
    () => cx(styles.frame, styles.dialogFrame),
    []
  );

  return (
    <div className={containerClassName}>
      <div className={styles.header}>
        <div className={styles.heading}>
          <Text size="3" weight="medium">
            Authenticate browser skill
          </Text>
          <Text size="2" color="gray">
            Sign in using the embedded browser, then click "Save Authentication".
          </Text>
        </div>
        <Flex gap="2">
          <Button variant="soft" color="gray" onClick={onCancel} disabled={submitting}>
            Cancel
          </Button>
          <Button highContrast onClick={onFinish} disabled={submitting}>
            Save authentication
          </Button>
        </Flex>
      </div>

      <div className={styles.body}>
        <iframe
          src={session.liveViewUrl}
          title="Hyperbrowser authentication"
          className={frameClassName}
          allow="clipboard-read; clipboard-write"
          sandbox="allow-same-origin allow-scripts allow-forms allow-popups"
        />
      </div>

      {error && (
        <Text size="2" color="red" className={styles.error}>
          {error}
        </Text>
      )}
    </div>
  );
}
